// extracted by mini-css-extract-plugin
export default {"container":"Tags_container__ShuRs"};